import { init, preRouteUpdateMetrics, getInstance } from '../helpers';
import useLocationChangeSync from '../../../hooks/useLocationChangeSync';
/**
 * create instance if not created already or reinitialize context on application change
 * and registers location change interceptor
 */
var usePageLoadPerformance = function (_a) {
    var appName = _a.appName;
    var performanceTracker = getInstance();
    if (!performanceTracker || (performanceTracker === null || performanceTracker === void 0 ? void 0 : performanceTracker.context) !== appName) {
        init({ appName: appName });
    }
    useLocationChangeSync(preRouteUpdateMetrics);
};
export default usePageLoadPerformance;
//# sourceMappingURL=usePageLoadPerformance.js.map